function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

export var mix = function mix(one, two, mergeArrays) {
  if (mergeArrays === void 0) {
    mergeArrays = false;
  }

  if (!one || !two || _typeof(one) !== "object" || _typeof(two) !== "object") return one;

  var clone = __assign({}, one);

  for (var prop in two) {
    if (two.hasOwnProperty(prop)) {
      if (two[prop] instanceof Array && one[prop] instanceof Array) {
        clone[prop] = mergeArrays ? __spreadArray(__spreadArray([], one[prop]), two[prop]) : two[prop];
      } else if (_typeof(two[prop]) === "object" && _typeof(one[prop]) === "object") {
        clone[prop] = mix(one[prop], two[prop], mergeArrays);
      } else {
        clone[prop] = two[prop];
      }
    }
  }

  return clone;
};